import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { File } from '../model/files';

@Injectable()
export class FileAccessService {
    private fileAccessURL = environment.endpoints.fileAccess;

    constructor(private http: HttpClient) {
    }

    getFilesList(): Promise<File[]> {
        return this.http
            .get(this.fileAccessURL + "view")
            .toPromise()
            .then(response => response as File[])
            .catch(this.handleError);
    }

    downloadFile(fileName: string): any {
        return this.http.post(this.fileAccessURL + "download", JSON.stringify({ fileName: fileName }), {responseType: 'blob'})
    }

    private handleError(error: any): Promise<any> {
        console.error('An error occurred', error);
        return Promise.reject(error.message || error);
    }
}